import { useState } from "react";
import FeaturedProducts from '../components/FeaturedProducts';
import ProductCategories from '../components/ProductCategories';
import useMetaTags from "../hooks/useMetaTags"; // Adjust path based on your project structure

const Products = () => {
  useMetaTags({
    title: "Organic Sanitary Pads | Natural & Chemical-Free Period Care",
    description: "Discover our premium organic sanitary pads made from natural materials. Chemical-free, eco-friendly, and gentle on your skin. Shop now for a healthier period!",
    keywords: "organic sanitary pads, chemical-free pads, natural period care, eco-friendly pads, biodegradable pads, best organic pads in India",
    author: "Organic Pads",
    robots: "index, follow",
    canonical: "/products",
    ogTitle: "Organic Sanitary Pads | Natural & Chemical-Free Period Care",
    ogDescription: "Say goodbye to harmful chemicals! Our organic sanitary pads offer ultimate comfort and protection. 100% biodegradable and eco-friendly.",
    ogImage: "https://organicpads.shop/logo.png",
    ogUrl: "https://organicpads.shop/products",
    ogType: "website",
    twitterCard: "summary_large_image",
    twitterTitle: "Organic Sanitary Pads | Natural & Chemical-Free Period Care",
    twitterDescription: "Switch to healthier period care with our organic sanitary pads. Natural, chemical-free, and skin-friendly. Order now!",
    twitterImage: "https://organicpads.shop/logo.png",
    twitterSite: "@OrganicPads",
    twitterCreator: "@OrganicPads",
  });

  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "name": "Organic Sanitary Pads Collection",
    "description": "Browse our collection of organic sanitary pads made from natural materials. Chemical-free, eco-friendly, and safe for your skin.",
    "url": "https://organicpads.shop/products",
    "itemListElement": [
      {
        "@type": "Product",
        "name": "Organic Cotton Sanitary Pads - Regular",
        "image": "https://organicpads.shop/images/product-image.png",
        "description": "Soft, breathable, and chemical-free organic cotton pads for daily comfort.",
        "sku": "OP-001",
        "brand": {
          "@type": "Brand",
          "name": "Organic Pads"
        },
        "offers": {
          "@type": "Offer",
          "priceCurrency": "INR",
          "price": "180",
          "availability": "https://schema.org/InStock",
          "url": "https://organicpads.shop/products/organic-pad-regular"
        }
      },
      {
        "@type": "Product",
        "name": "Organic Cotton Sanitary Pads - Heavy Flow",
        "image": "https://organicpads.shop/images/product-image.png",
        "description": "Extra absorbent and comfortable organic cotton pads for heavy flow days.",
        "sku": "OP-002",
        "brand": {
          "@type": "Brand",
          "name": "Organic Pads"
        },
        "offers": {
          "@type": "Offer",
          "priceCurrency": "INR",
          "price": "250",
          "availability": "https://schema.org/InStock",
          "url": "https://organicpads.shop/products/organic-pad-heavy"
        }
      }
    ]
  }
  
  
  const products = {
    "Dry Comfort": {
      sizes: {
        Regular: {
          size: "230MM",
          image: "/images/product-image.png",
          description:
            "Dry Comfort range sanitary pads are 230 mm long and keep you feeling comfortable and dry.",
          features: [
            "Double Perforated Top sheet quickly absorbs the flow and helps keep you dry.",
            "Fresh Fragrance locks the bad odour to keep you feeling fresh all day long.",
            "Soft Edge Arms provide better protection and comfort.",
          ],
        },
        XL: {
          size: "282MM",
          image: "/images/product-image.png",
          description:
            "Dry Comfort XL pads provide better coverage and absorption.",
          features: [
            "Enhanced absorption with a wider design.",
            "Odour-lock technology for freshness.",
            "Comfortable and breathable material.",
          ],
        },
        "ULTRA THIN XL": {
          size: "282MM",
          image: "/images/product-image.png",
          description:
            "Dry Comfort XL pads provide better coverage and absorption.",
          features: [
            "Enhanced absorption with a wider design.",
            "Odour-lock technology for freshness.",
            "Comfortable and breathable material.",
          ],
        },
        "ULTRA THIN XL +": {
          size: "282MM",
          image: "/images/product-image.png",
          description:
            "Dry Comfort XL pads provide better coverage and absorption.",
          features: [
            "Enhanced absorption with a wider design.",
            "Odour-lock technology for freshness.",
            "Comfortable and breathable material.",
          ],
        },
      },
      content:"Niine sanitary napkins Dry Comfort range comes with a double perforated top sheet that absorbs heavy flow and keeps you comfortable and active during periods."
    },
    "Naturally Soft": {
      sizes: {
        Regular: {
          size: "230MM",
          image: "/images/product-image.png",
          description:
            "Naturally Soft range provides extra softness with cotton feel.",
          features: [
            "Super soft material for better comfort.",
            "Breathable layer for irritation-free experience.",
            "Absorbs moisture quickly to keep you dry.",
          ],
        },
        XL: {
          size: "282MM",
          image: "/images/product-image.png",
          description:
            "Naturally Soft XL pads provide more comfort and better absorption.",
          features: [
            "Cotton-feel material for a soft experience.",
            "Locks in moisture without irritation.",
            "Provides extra coverage and protection.",
          ],
        },
      },
      content:"The Naturally Soft range has been specifically developed for girls & women with sensitive skin. They are skin-friendly and efficiently take care of your comfort during periods."
    },
  };

  const [selectedCategory, setSelectedCategory] = useState("Dry Comfort");
  const [selectedSize, setSelectedSize] = useState("Regular");

  const currentProduct = products[selectedCategory].sizes[selectedSize];

  return (
    <div className="p-6 max-w-5xl mx-auto text-center">

    <FeaturedProducts/>
      {/* Category Selection */}
      <div className="flex justify-center  space-x-4">
        {Object.keys(products).map((category) => (
          <button
            key={category}
            onClick={() => setSelectedCategory(category)}
            className={`px-4 py-2 rounded-lg text-2xl font-bold uppercase ${
              selectedCategory === category ? "bg-[#679729] text-white" : "text-[#679729]"
            }`}
          >
            {category}
          </button>
        ))}
      </div>

      <p className="mt-8 p-8 text-gray-700 ">{products[selectedCategory].content}</p>

      {/* Size Selection */}
      <div className="flex justify-center space-x-4 mt-8">
        {Object.keys(products[selectedCategory].sizes).map((size) => (
          <button
            key={size}
            onClick={() => setSelectedSize(size)}
            className={`px-4 py-2  font-bold rounded-lg ${
              selectedSize === size ? "bg-[#679729] text-white" : "text-[#679729]"
            }`}
          >
            {size} ({products[selectedCategory].sizes[size].size})
          </button>
        ))}
      </div>

      {/* Product Display */}
      <div className="mt-6">
        <img
          src={currentProduct?.image}
          alt={selectedSize}
          className="mx-auto h-50"
        />
        <p className="mt-4 text-gray-700">{currentProduct.description}</p>
      </div>

      {/* Features */}
      <div className="mt-6 text-left">
        <h3 className="text-2xl font-bold text-[#679729]">Product Features:</h3>
        <ul className="list-disc list-inside text-gray-600">
          {currentProduct.features.map((feature, index) => (
            <li key={index}>{feature}</li>
          ))}
        </ul>
      </div>
      <ProductCategories/>
      {/* Schema Markup */}
      <script type="application/ld+json">
        {JSON.stringify(schemaMarkup)}
      </script>
    </div>
  );
};
  
export default Products;
